import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ = [
  {
    q: "MamaMatch est-elle gratuite ?",
    a: "Nous souhaitons que MamaMatch reste accessible au plus grand nombre. Les modalités précises (gratuité, formules, options premium éventuelles) seront communiquées avant le lancement officiel.",
  },
  {
    q: "Où puis-je télécharger MamaMatch ?",
    a: "MamaMatch est disponible dès maintenant, gratuitement, sur l'App Store (iOS) et Google Play (Android). Recherche « MamaMatch » sur ton store ou utilise les boutons de téléchargement en haut de cette page.",
  },
  {
    q: "Dans quelles villes MamaMatch est disponible ?",
    a: "MamaMatch est disponible dans toute la France dès aujourd'hui — pas de déploiement ville par ville. Que tu sois à Paris, en région ou dans un petit village, tu peux rencontrer les mamans les plus proches de chez toi dès l'ouverture de l'app.",
  },
  {
    q: "Comment fonctionne le matching ?",
    a: "Le matching prend en compte trois critères : ta géolocalisation (rue, quartier, ville), l'étape de maternité que tu vis actuellement (grossesse, post-partum, allaitement, sommeil, diversification…), et l'âge de ton enfant. L'algorithme te propose en priorité des mamans qui te ressemblent le plus dans le moment présent.",
  },
  {
    q: "Est-ce que mes données sont protégées ?",
    a: "Oui. Tes données sont hébergées en France, protégées dans le respect du RGPD, et ne sont jamais revendues. Tu pourras supprimer ton compte à tout moment, avec effacement complet.",
  },
  {
    q: "Puis-je participer si je suis encore enceinte ?",
    a: "Oui — MamaMatch accompagne aussi les futures mamans. Tu peux rencontrer d'autres femmes en grossesse près de chez toi, échanger et créer des liens dès aujourd'hui.",
  },
];

const EASE = [0.2, 0.7, 0.2, 1];

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-20 md:py-32 bg-[#F7F5F2]"
    >
      <div className="mx-auto max-w-[1000px] px-5 md:px-8">
        <div className="max-w-[720px] mb-12 md:mb-16">
          <p className="text-[13px] font-semibold uppercase tracking-[0.14em] text-[#D97757]">
            Questions fréquentes
          </p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: EASE }}
            className="mt-4 font-display text-[32px] sm:text-[42px] md:text-[52px] text-[#0A0A0A]"
          >
            Tout ce que tu te demandes.
          </motion.h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {FAQ.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              className="border-b border-[rgba(10,10,10,0.1)]"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-display text-[17px] md:text-[20px] text-[#0A0A0A] hover:no-underline py-6 [&[data-state=open]>svg]:rotate-45 [&>svg]:transition-transform [&>svg]:duration-300 [&>svg]:text-[#0A0A0A]/50">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[15px] leading-[1.6] text-[#6B6660] pb-6 max-w-[720px]">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
